import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Paper, Grid, Card } from '@mui/material';
import { useStore } from '../stores';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import ChangePassword from '../components/common/ChangePassword';

const Settings: React.FC = () => {
    const { authStore } = useStore();

    const handleSavePassword = async (passwords: {
        currentPassword: string;
        newPassword: string;
    }) => {
        console.log('Enviando cambio de contraseña:', passwords);

        await new Promise(resolve => setTimeout(resolve, 1000));

        return true;
    };

    return (
        <DashboardLayout>
            <Box>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Configuración
                </Typography>

                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6, lg: 7, xl: 7 }}>
                        <ChangePassword onSave={handleSavePassword} />
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout >
    );
};

export default observer(Settings);